// extracted by mini-css-extract-plugin
module.exports = {"modal":"style_modal__Gmfty","paper":"style_paper__3k3rW"};